import { Popover as MaterialPopover } from '@mui/material';
import React, { Fragment } from 'react';

export class Popover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchor: null,
    };
  }

  onClose = () => this.setState({ anchor: null });
  onOpen = (anchor) => this.setState({ anchor });

  render() {
    const {
      renderTrigger,
      renderContent,
      anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'center',
      },
      ...rest
    } = this.props;
    const { anchor } = this.state;
    const props = { onClose: this.onClose, onOpen: this.onOpen };
    return (
      <Fragment>
        {renderTrigger(props)}
        <MaterialPopover
          {...rest}
          open={Boolean(anchor)}
          anchorOrigin={anchorOrigin}
          anchorEl={anchor}
          onClose={this.onClose}
        >
          {renderContent(props)}
        </MaterialPopover>
      </Fragment>
    );
  }
}
